/*jshint esversion: 9 */
import React from "react";
import { Fragment } from "react";
import { connect } from "react-redux";
// import { withStyles } from "@material-ui/core/styles";
// import { checkValidity, notNull, updateObject } from "../shared/utility";
import { doLog, hasValue } from "../../shared/utility";

import * as actions from "../../store/actions/index";
import classes from "../CrimeSubmission.css";
import Button from "@material-ui/core/Button";
import Form from "../../components/UI/Form/Form";
import Grid from "@material-ui/core/Grid";
import LandingPage from "../../components/Navigation/LandingPage/LandingPage";
import ManageAgency from "./ManageAgency";
import ManageIncidentType from "./ManageIncidentType";
import ManageValidCode from "./ManageValidCode";
import Select from "react-select";

// const styles = (theme) => ({
//   root: {
//     flexGrow: 1,
//     backgroundColor: theme.palette.background.paper,
//   },
//   textField: {
//     width: 250,
//   },
//   dense: {
//     marginTop: 19,
//   },
//   spacing: 1,
//   table: { "& .MuiTableCell-head": { fontWeight: 700 } },
// });

const gridSpacing = 0; //0 or 8 or 16 or 24 or 32 or 40

class ManageDB extends Form {
  state = {
    searching: false,
    reportRunning: false,
    editMode: true,
    action: "",
    actionOption: null,
    //
    agencyOption: null,
    agencyDisabled: false,
    agencyEdit: false,
    agencyAdd: false,
    agencyORI: "",
  };

  componentDidMount() {
    if (doLog()) console.log("[ManageDB] componentDidMount state:", this.state);
    if (doLog()) console.log("[ManageDB] componentDidMount props:", this.props);
    if (this.props.isAuthenticated) {
      if (this.props.webAgencyList === null) {
        const transactionType =
          '<CIDDB><QUERY TABLE="CitizenWebAgency" LIMIT="9999" OPERATORID="-1"><FIELD_LIST>ALL</FIELD_LIST></QUERY></CIDDB>';
        const data = {};
        const request = {
          transactionType,
          data,
        };
        this.setState({ searching: true });
        this.props.onRunTransaction(request, this.props.token, "webAgencyList");
      }
    }
    this.checkForSpecificAgency();
  }

  componentDidUpdate() {
    if (doLog())
      console.log("[ManageDB] componentDidUpdate state:", this.state);
    if (doLog())
      console.log("[ManageDB] componentDidUpdate props:", this.props);
    if (this.props.isAuthenticated) {
      if (
        this.state.searching &&
        this.props.error === null &&
        ((this.props.transDesc === "webAgencyList" &&
          hasValue(this.props.webAgencyList)) ||
          hasValue(this.props.result))
      ) {
        if (doLog())
          console.log(
            "[ManageDB] componentDidUpdate result:",
            this.props.result
          );
        if (doLog())
          console.log(
            "[ManageDB] componentDidUpdate transDesc:",
            this.props.transDesc
          );
        this.setState({ searching: false });
      } else if (this.props.webAgencyList === null && !this.state.searching) {
        const transactionType =
          '<CIDDB><QUERY TABLE="CitizenWebAgency" LIMIT="9999" OPERATORID="-1"><FIELD_LIST>ALL</FIELD_LIST></QUERY></CIDDB>';
        const data = {};
        const request = {
          transactionType,
          data,
        };
        this.setState({ searching: true });
        this.props.onRunTransaction(request, this.props.token, "webAgencyList");
      } else if (
        this.props.transDesc === "webAgencyUpdate" &&
        (this.props.result === null ||
          !hasValue(this.props.result.RESULT.CITIZENWEBAGENCY))
      ) {
        const transactionType =
          '<CIDDB><QUERY TABLE="CitizenWebAgency" LIMIT="9999" OPERATORID="-1"><FIELD_LIST>ALL</FIELD_LIST></QUERY></CIDDB>';
        const data = {};
        const request = {
          transactionType,
          data,
        };
        this.setState({ searching: true });
        this.props.onRunTransaction(request, this.props.token, "webAgencyList");
      } else if (
        this.props.webAgencyList !== null &&
        this.props.transDesc === "webAgencyList" &&
        this.state.searching
      ) {
        if (doLog())
          console.log(
            "[ManageDB] componentDidUpdate clearing webAgencyList transDesc"
          );
        this.setState({ searching: false });
        this.props.onClearTransactionResult();
        this.props.onClearTransDesc();
      }

      if (
        hasValue(this.props.webAgencyList) &&
        !hasValue(this.state.agencyOption) &&
        this.props.modulePermissions &&
        this.props.modulePermissions.allowedAgencyCode !== "ALL"
      ) {
        let index = this.props.webAgencyList.findIndex((element) => {
          return (
            element.AGENCYCODE ===
            this.props.modulePermissions.allowedAgencyCode.toUpperCase()
          );
        });
        if (doLog()) console.log("[ManageDB] componentDidUpdate index:", index);
        const row = this.props.webAgencyList[index];
        if (doLog()) console.log("[ManageDB] componentDidUpdate row:", row);
        if (hasValue(row)) {
          const selectedAgency = {
            value: index,
            label: row.NAME,
          };
          this.setState({
            agencyOption: selectedAgency,
            agencyDisabled: true,
            agencyORI: row.ORI,
          });
        }
      }
    }
    this.checkForSpecificAgency();
  }

  checkForSpecificAgency() {
    if (
      hasValue(this.props.webAgencyList) &&
      !hasValue(this.state.agencyOption) &&
      this.props.modulePermissions &&
      this.props.modulePermissions.allowedAgencyCode !== "ALL"
    ) {
      let index = this.props.webAgencyList.findIndex((element) => {
        return (
          element.AGENCYCODE ===
          this.props.modulePermissions.allowedAgencyCode.toUpperCase()
        );
      });
      if (doLog()) console.log("[Review] checkForSpecificAgency index:", index);
      const row = this.props.webAgencyList[index];
      if (doLog()) console.log("[Review] checkForSpecificAgency row:", row);
      if (hasValue(row)) {
        const selectedAgency = {
          value: index,
          label: row.NAME,
        };
        this.setState({
          agencyOption: selectedAgency,
          agencyDisabled: true,
          agencyORI: row.ORI,
          agencyCode: this.props.modulePermissions.allowedAgencyCode,
        });
      }
    }
  }

  handleActionAddButton = () => {
    if (doLog()) console.log("[ManageDB] handleActionAddButton");
    this.setState({ actionEdit: false, actionAdd: true });
  };

  handleActionCancel() {
    if (doLog()) console.log("[ManageDB] handleActionCancel");
    this.setState({ actionEdit: false, actionAdd: false });
  }

  handleActionDelete() {
    if (doLog()) console.log("[ManageDB] handleActionDelete");
    // this.setState({ actionEdit: false, actionAdd: false, actionOption: null });
    this.setState({ actionEdit: false, actionAdd: false });
  }

  handleActionSelectionChange = (actionSelected) => {
    if (actionSelected.value === -1) {
      this.setState({ action: "", actionOption: null });
    } else {
      this.setState({ action: actionSelected, actionOption: null });
    }
    if (doLog())
      console.log(
        `[ManageDB] handleActionSelectionChange actionSelected:`,
        actionSelected
      );
    this.props.onClearTransactionResult();
    this.props.onClearTransDesc();
  };

  handleAgencyAddButton = () => {
    if (doLog()) console.log("[ManageDB] handleAgencyAddButton");
    this.setState({
      agencyEdit: false,
      agencyAdd: true,
      action: "",
      actionOption: null,
    });
  };

  handleAgencyChange = (agencySelected) => {
    if (agencySelected.value === -1) {
      this.setState({
        agencyOption: null,
        agencyEdit: false,
        agencyAdd: true,
        agencyORI: "",
        action: "",
        actionOption: null,
      });
    } else {
      this.setState({
        agencyOption: agencySelected,
        agencyEdit: false,
        agencyAdd: false,
        agencyORI: this.props.webAgencyList[agencySelected.value].ORI,
        action: "",
        actionOption: null,
      });
    }
    if (doLog())
      console.log(
        `[ManageDB] handleAgencyChange optionSelected:`,
        agencySelected
      );
    this.props.onClearTransactionResult();
  };

  handleAgencyCancel() {
    if (doLog()) console.log("[ManageDB] handleAgencyCancel");
    this.setState({ agencyEdit: false, agencyAdd: false });
  }

  handleAgencyDelete() {
    if (doLog()) console.log("[ManageDB] handleAgencyDelete");
    this.setState({ agencyEdit: false, agencyAdd: false, agencyOption: null });
  }

  handleAgencyEditButton = () => {
    if (doLog()) console.log("[ManageDB] handleAgencyEditButton");
    this.setState({ agencyEdit: true, agencyAdd: false });
  };

  handleOptionChange = (optionSelected) => {
    if (optionSelected.value === -1) {
      this.setState({ actionOption: null, actionEdit: false, actionAdd: true });
    } else {
      this.setState({
        actionOption: optionSelected,
        actionEdit: true,
        actionAdd: false,
      });
    }
    if (doLog())
      console.log(
        `[ManageDB] handleOptionChange optionSelected:`,
        optionSelected
      );
  };

  render() {
    // if (doLog()) console.log("[ManageDB] render");
    if (doLog()) console.log("[ManageDB] render props:", this.props);

    let errorMessage = null;
    if (this.props.error) {
      errorMessage = (
        <Grid item xs={12}>
          <p>{this.props.error.message}</p>
        </Grid>
      );
    }

    let formHeader = (
      <Grid container item spacing={gridSpacing}>
        <Grid item xs={12} className={classes.FormHeader}>
          <p>Configure</p>
        </Grid>
        {errorMessage}
      </Grid>
    );

    //-----------------------------------------------------------
    let agencySection = null;
    let agencyOptions = [];
    let agencySelect = null;
    let editButtonSection = null;
    if (this.props.webAgencyList !== null) {
      for (let i = 0; i < this.props.webAgencyList.length; i++) {
        const fields = this.props.webAgencyList[i];
        if (fields.AGENCYCODE !== "DEFAULTDATA") {
          agencyOptions.push({ value: i, label: fields.NAME });
        }
      }
      if (doLog())
        console.log(
          "[ManageDB] render webAgencyList length:",
          this.props.webAgencyList.length
        );
      if (doLog())
        console.log("[ManageDB] render agencyOptions:", agencyOptions);
      if (doLog())
        console.log("[ManageDB] render agencyOption:", this.state.agencyOption);

      if (hasValue(this.state.agencyOption)) {
        editButtonSection = (
          <Fragment>
            &nbsp;&nbsp;
            <Button
              variant="contained"
              //color="default"
              color="primary"
              size="small"
              onClick={this.handleAgencyEditButton.bind(this)}
            >
              Edit
            </Button>
          </Fragment>
        );
      }

      agencySelect = (
        <Grid container item>
          <Grid item xs={8}>
            <Select
              value={this.state.agencyOption}
              onChange={this.handleAgencyChange}
              options={agencyOptions}
              isSearchable="true"
              isDisabled={this.state.agencyDisabled}
            />
          </Grid>
          <Grid item xs={4}>
            {/* &nbsp;&nbsp;
            <Button
              variant="contained"
              color="default"
              size="small"
              onClick={this.handleAgencyEditButton.bind(this)}
            >
              Edit
            </Button> */}
            {editButtonSection}
            &nbsp;&nbsp;
            <Button
              variant="contained"
              //color="default"
              color="primary"
              size="small"
              onClick={this.handleAgencyAddButton.bind(this)}
              disabled={this.state.agencyDisabled}
            >
              Add another
            </Button>
          </Grid>
        </Grid>
      );

      if (
        hasValue(this.state.agencyDisabled) &&
        this.state.agencyDisabled === true
      ) {
        agencySection = (
          <Grid container item>
            <Grid item xs={12}>
              <p className={classes.ResultLabel}>Agency Information</p>
            </Grid>
            <Grid item xs={12}>
              <p>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Agency:{" "}
                {this.state.agencyOption.label}
                &nbsp;&nbsp;
                <Button
                  variant="contained"
                  //color="default"
                  color="primary"
                  size="small"
                  onClick={this.handleAgencyEditButton.bind(this)}
                >
                  Edit
                </Button>
              </p>
            </Grid>
          </Grid>
        );
      } else {
        agencySection = (
          <Grid container item>
            <Grid item xs={12}>
              <p className={classes.ResultLabel}>Agency Information</p>
            </Grid>
            <Grid item xs={12}>
              <p>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Select an
                Agency:
              </p>
              {agencySelect}
            </Grid>
          </Grid>
        );
      }
    }

    let agencyFormSection = null;
    if (this.props.webAgencyList !== null) {
      const array = this.props.webAgencyList;
      if (this.state.agencyEdit || this.state.agencyAdd || array.length === 0) {
        let keyValue = -1;
        let itemValue = -1;
        if (this.state.agencyOption !== null && this.state.agencyEdit) {
          keyValue = array[this.state.agencyOption.value].agencyCode;
          itemValue = array[this.state.agencyOption.value];
        }
        agencyFormSection = (
          <ManageAgency
            key={keyValue}
            item={itemValue}
            add={this.state.agencyAdd || array.length === 0}
            onAddAnother={this.handleAgencyAddButton.bind(this)}
            onCancel={this.handleAgencyCancel.bind(this)}
            onDelete={this.handleAgencyDelete.bind(this)}
          />
        );
      }
    }

    //-----------------------------------------------------------
    let actionSelect = null;
    let actionOptions = [];
    if (
      this.props.isAuthenticated != null &&
      this.state.agencyOption !== null &&
      this.state.agencyEdit === false &&
      this.state.agencyAdd === false
    ) {
      actionOptions = [
        { value: "IncidentTypes", label: "Incident Types" },
        { value: "PersonInvolvement", label: "Person Involvement Role Codes" },
        { value: "PropertyType", label: "Property Type Codes" },
        {
          value: "VehicleInvolvement",
          label: "Vehicle Involvement Role Codes",
        },
        { value: "VehicleBodyStyle", label: "Vehicle Body Style Codes" },
        { value: "VehicleMake", label: "Vehicle Make Codes" },
        { value: "VehiclePropertyColor", label: "Vehicle PropertyColor Codes" },
        { value: "Race", label: "Race Codes" },
        { value: "Ethnicity", label: "Ethnicity Codes" },
        { value: "Gender", label: "Gender Codes" },
        { value: "EyeColor", label: "Eye Color Codes" },
        { value: "HairColor", label: "Hair Color Codes" },
        { value: "State", label: "State Codes" },
      ];

      actionSelect = (
        <Grid container item>
          <Grid item xs={12}>
            <p className={classes.ResultLabel}>Agency Database Tables</p>
          </Grid>
          <Grid item xs={12}>
            <p>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Select a database
              table to edit:
            </p>
            <Select
              value={this.state.action}
              onChange={this.handleActionSelectionChange}
              options={actionOptions}
              isSearchable="true"
            />
          </Grid>
        </Grid>
      );
    }

    //-----------------------------------------------------------
    let formSection = null;
    if (!(this.state.agencyEdit || this.state.agencyAdd)) {
      if (
        hasValue(this.state.action) &&
        hasValue(this.state.action.value) &&
        this.state.action.value === "IncidentTypes"
      ) {
        if (doLog())
          console.log(
            "[ManageDB] render action value:",
            this.state.action.value
          );
        const ori = this.state.agencyORI;
        formSection = (
          <ManageIncidentType key={this.state.action.value} ori={ori} />
        );
      } else if (
        this.state.action !== "" &&
        hasValue(this.state.action.value) &&
        this.state.action.value !== "IncidentTypes"
      ) {
        if (doLog())
          console.log(
            "[ManageDB] render action value:",
            this.state.action.value
          );
        const ori = this.state.agencyORI;
        formSection = (
          <ManageValidCode
            key={this.state.action.value}
            ori={ori}
            listName={this.state.action.value}
          />
        );
      }
    }

    let formFields = (
      <Grid container item spacing={gridSpacing} className={classes.LongerCard}>
        <Grid item xs={12} className={classes.FormFields}>
          <Grid container item>
            {/* <p className={classes.Information}>Configure</p>
            <Grid item xs={12}>
              <hr />
            </Grid> */}
            {agencySection}
            {agencyFormSection}
            {actionSelect}
            {formSection}
          </Grid>
        </Grid>
      </Grid>
    );

    //-----------------------------------------------------------
    return (
      <Fragment>
        <LandingPage />
        <div className={classes.CrimeSubmission}>
          <Grid container item spacing={gridSpacing}>
            {formHeader}
            {formFields}
          </Grid>
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  if (doLog()) console.log("[ManageDB].mapStateToProps state:", state);
  return {
    loading: state.trans.loading,
    result: state.trans.result,
    transDesc: state.trans.transDesc,
    error: state.trans.error,
    authError: state.auth.error,
    isAuthenticated: state.auth.token !== null,
    authRedirectPath: state.auth.authRedirectPath,
    //
    reportResult: state.trans.reportResult,
    reportError: state.trans.reportError,
    //
    upLoadNextIndex: state.trans.upLoadNextIndex,
    upLoadFileResult: state.trans.upLoadFileResult,
    upLoadFileError: state.trans.upLoadFileError,
    //
    agencyCode: state.trans.agencyCode,
    modulePermissions: state.auth.modulePermissions,
    configuration: state.trans.configuration,
    //
    webAgencyList: state.trans.webAgencyList,
    //
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onRunTransaction: (options, token, transDesc) =>
      dispatch(actions.runTransaction(options, token, transDesc)),
    onClearTransactionResult: () => dispatch(actions.clearTransactionResult()),
    onClearTransDesc: () => dispatch(actions.clearTransDesc()),
    onClearReportResult: () => dispatch(actions.clearReportResult()),
  };
};

// export default withStyles(styles)(
//   connect(mapStateToProps, mapDispatchToProps)(ManageDB)
// );
export default connect(mapStateToProps, mapDispatchToProps)(ManageDB);
